import {client as http, axiosInstance} from "@/http_client";
import {apiUrl} from "../../constants/config";

export default {
    state: {
        conference: null
    },
    getters: {
        conference: state => state.conference
    },
    mutations: {

    },
    actions: {
        getConferenceByCode({}, code) {
            return new Promise((resolve, reject) => {
                http.get('app/conferences/code/' + code).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        getConferenceById({state}, id) {
            return new Promise((resolve, reject) => {
                http.get('app/conferences/' + id).then(response => {
                    state.conference = response.data;
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        getConferences({}) {
            return new Promise((resolve, reject) => {
                http.get('app/conferences/').then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        sendConferenceEmail({}, payload) {
            return new Promise((resolve, reject) => {
                http.post('app/conferences/' + payload.id + '/email', payload.data).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        }
    }
}
